module.exports = require('./lib/ecies');
